export default __webpack_public_path__ + "static/media/Boots of Crimson Slaughter.c9227bb9.jpg";